import { ServerResponse } from './server-response.model';

export class GetHeaderMain {
  project = '';
  typeProject = '';
  typeProperty = '';
}

export class GetHeaderModel extends ServerResponse {
  response: CalendarMainModel;
}

export class CalendarMainModel {
  projectLogo: string;
  typeProject: TypeProject;
  typesProperty: TypesProperty[];
  typePropertySelected: TypesProperty;
}

export class WorkingHour {
  weekDay: number;
  opensAt: string;
  closesAt: string;
}

export class TypeProject {
  id: string;
  label: string;
  workingHours: WorkingHour[];
}

export class TypesProperty {
  id: string;
  label: string;
  detail: string;
  area: string;
  features: string[];
}

export class DataInProgress {
  project: string;
  projectLogo?: string;
  typeProject: string;
  propertyId: string;
  propertyName: string;

  day: string;
  hour: string;

  interests: Interests[];
  interestExtraNotes: string;
  question?: string;
  answer?: string;

  name?: string;
  firstName: string;
  lastName: string;
  password: string;
  phone: string;
  email: string;
  acceptPoliciesAndTerms?: boolean;

  accessToken: string;
  uid: string;
  profilePhoto: string;
  originAccount: string;
  broker: string;
}

export enum TypeDataInProgress {
  project = 'getProjectData',
  selectProperty = 'selectProperty',
  day = 'day',
  hour = 'hour',
  preferences = 'preferences',
  newAccount = 'newAccount',
  socialMedia = 'socialMedia',
  projectLogo = 'projectLogo',
  broker = 'broker',
}

export class GetInterestsModel extends ServerResponse {
  response: Interests[];
}

export class Interests {
  id: string;
  name: string;
}

export class SignUpWithScheduleVisit {
  email: string;
  acceptPoliciesAndTerms?: boolean;
  password: string;
  name: {
    firstName: string;
    lastName: string;
  };
  phone: string;
  interests: Interests[];
  interestExtraNotes: string;
  answer: string;
  question: string;
  project: string;
  typeProject: string;
  typeProperty: string;
  projectLogo: string;
  visit: {
    date: string;
    broker: string;
  };
  accessToken: string;
  uid: string;
  profilePhoto: string;
  originAccount: string;
}

export class SignUpWithoutScheduleVisit {
  email: string;
  acceptPoliciesAndTerms?: boolean;
  password?: string;
  name: {
    firstName: string;
    lastName?: string;
  };
  phone?: string;
  accessToken?: string;
  uid?: string;
  originAccount?: string;
}
